import { useEffect, useState } from "react";
import Drawer from "components/shared/Drawer/Drawer";
import { PaymentDetailsContent } from "./PaymentDetails";
import { TransactionDetailContent } from "./TransactionDetailSheet";
import { DrawerScreen } from "./styles.payoutDesktop";
import { NESTED_DRAWER_LAYER } from "./config";

export default function PayoutDetailDrawer({ referenceNumber, transaction, onClose }) {
  const [nestedTransaction, setNestedTransaction] = useState(null);

  // a different (or closed) payment starts without a transaction open on top of it
  useEffect(() => {
    setNestedTransaction(null);
  }, [referenceNumber]);

  if (!referenceNumber && !transaction) return null;

  return (
    <>
      <Drawer
        title={referenceNumber ? "Payment details" : "Transaction detail"}
        onClose={onClose}
      >
        <DrawerScreen>
          {referenceNumber ? (
            <PaymentDetailsContent
              referenceNumber={referenceNumber}
              onOpenTransaction={setNestedTransaction}
            />
          ) : (
            <TransactionDetailContent item={transaction} />
          )}
        </DrawerScreen>
      </Drawer>
      {referenceNumber && nestedTransaction ? (
        <Drawer
          title="Transaction detail"
          layer={NESTED_DRAWER_LAYER}
          onClose={() => setNestedTransaction(null)}
        >
          <DrawerScreen>
            <TransactionDetailContent item={nestedTransaction} />
          </DrawerScreen>
        </Drawer>
      ) : null}
    </>
  );
}
